module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-03.d2e3b535.png";